import React from 'react'
import { Alert, Modal } from 'antd'

function uniqueProjectNames(projects) {
    return Array.from(new Set((projects || []).map(item => String(item || '').trim()).filter(Boolean)))
}

export function confirmAuthorizationDocumentationWarnings(warnings, onContinue) {
    // 2026-07-31 coder(lq): Combine all incomplete projects into one non-blocking authorization confirmation.
    const databaseProjects = uniqueProjectNames(warnings?.databaseProjects)
    const apiProjects = uniqueProjectNames(warnings?.apiProjects)
    if (!databaseProjects.length && !apiProjects.length) {
        onContinue()
        return
    }

    Modal.confirm({
        title: '授权说明不完善，是否继续？',
        width: 620,
        okText: '继续授权',
        cancelText: '返回完善',
        content: (
            <div>
                {databaseProjects.length ? (
                    <Alert
                        showIcon
                        type="warning"
                        message="授权数据库权限"
                        description={(
                            <div>
                                <div>数据字典必须有有效内容，否则授权后，被授权人可能无法获取数据，是否继续？可以让 Codex 完善数据字典。</div>
                                <div style={{ marginTop: 8 }}>缺少数据字典：{databaseProjects.join('、')}</div>
                            </div>
                        )}
                        style={{ marginTop: 12 }}
                    />
                ) : null}
                {apiProjects.length ? (
                    <Alert
                        showIcon
                        type="warning"
                        message="授权接口权限"
                        description={(
                            <div>
                                <div>必须存在接口说明，否则被授权人可能无法正确调用接口。</div>
                                <div style={{ marginTop: 8 }}>缺少接口说明：{apiProjects.join('、')}</div>
                            </div>
                        )}
                        style={{ marginTop: 12 }}
                    />
                ) : null}
            </div>
        ),
        onOk: onContinue,
    })
}
